import { defineMessages } from 'react-intl';

export default defineMessages({
  noResultsFound: {
    id: 'common.search.noResultsFound',
    defaultMessage: 'No results found',
  },
});
